export const BODY_CHART_CARE_PLAN_TYPE = "body chart";

export const BODY_CHART_IMAGE_PATH = "/body-chart/body-chart.png";

export type BodyChartView = "front" | "back";

export type BodyChartMarkerCode = "R" | "B" | "S" | "A" | "T" | "U" | "C" | "O";

export interface BodyChartMarkerOption {
  code: BodyChartMarkerCode;
  label: string;
  color: string;
  textColor: string;
}

export interface BodyChartMarker {
  id: string;
  view: BodyChartView;
  x: number;
  y: number;
  markerCode: BodyChartMarkerCode;
  markerLabel: string;
  note?: string;
}

export const BODY_CHART_MARKER_OPTIONS: BodyChartMarkerOption[] = [
  { code: "R", label: "Redness", color: "#ef4444", textColor: "#ffffff" },
  { code: "B", label: "Bruise", color: "#7c3aed", textColor: "#ffffff" },
  { code: "S", label: "Swelling", color: "#2563eb", textColor: "#ffffff" },
  { code: "A", label: "Abrasion", color: "#ea580c", textColor: "#ffffff" },
  { code: "T", label: "Skin tear", color: "#f97316", textColor: "#ffffff" },
  { code: "U", label: "Ulcer / pressure injury", color: "#be123c", textColor: "#ffffff" },
  { code: "C", label: "Cut / scratch", color: "#16a34a", textColor: "#ffffff" },
  { code: "O", label: "Other", color: "#475569", textColor: "#ffffff" },
];

export const BODY_CHART_MARKER_OPTION_BY_CODE = BODY_CHART_MARKER_OPTIONS.reduce<Record<string, BodyChartMarkerOption>>((result, option) => {
  result[option.code] = option;
  return result;
}, {});

export const normalizeBodyChartMarkers = (value: any): BodyChartMarker[] => {
  const items = Array.isArray(value) ? value : [];
  return items
    .map((item: any, index: number) => {
      const markerCode = String(item?.markerCode || "").trim().toUpperCase() as BodyChartMarkerCode;
      const option = BODY_CHART_MARKER_OPTION_BY_CODE[markerCode];
      const view = String(item?.view || "").trim() as BodyChartView;
      const x = Number(item?.x);
      const y = Number(item?.y);
      if (!option || (view !== "front" && view !== "back") || !Number.isFinite(x) || !Number.isFinite(y)) {
        return null;
      }

      return {
        id: String(item?.id || `body-marker-${index + 1}`).trim(),
        view,
        x: Math.min(1, Math.max(0, x)),
        y: Math.min(1, Math.max(0, y)),
        markerCode: option.code,
        markerLabel: String(item?.markerLabel || option.label).trim() || option.label,
        note: String(item?.note || ""),
      } as BodyChartMarker;
    })
    .filter((item): item is BodyChartMarker => !!item && !!item.id);
};
